import { TypedUseSelectorHook, useSelector } from "react-redux";
import { INotification } from "./notification.interface";
import { IEventState } from "./events.interface";
import { IAttendeesState } from "./attendees.interface";
import { IDownloadsState } from "./downloads.interface";
import { ISubscriptionsState } from "./subscriptions.interface";
import { IMarketingState } from "./marketing.interface";
import { IReportsState } from "./reports.interface";
import { Settings } from "../../api";

export interface IRootStateType {
  settings?: Settings | "loading" | "error";
}

export interface IStateType {
  root: IRootStateType;
  notifications: INotificationState;
  event: IEventState;
  attendees: IAttendeesState;
  downloads: IDownloadsState;
  subscriptions: ISubscriptionsState;
  marketing: IMarketingState;
  reports: IReportsState;
}

export interface IActionBase {
  type: string;
  [prop: string]: any;
}

export interface INotificationState {
  notifications: INotification[];
}

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
  (dispatch: (action: TAction) => void, getState: () => IStateType): void;
}

export const useTypedSelector: TypedUseSelectorHook<IStateType> = useSelector;
